import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import event from "../lib/mixins/event";

gsap.registerPlugin(ScrollTrigger);

const Y_MIN = 300;
const Y_MAX = 500;
const ROT_MIN = -10;
const ROT_MAX = 10;

function randBetween(min, max) {
	return min + Math.random() * (max - min);
}

class PhotoCollage {
	constructor(dom) {
		this.NAME = "PhotoCollage";
		this.dom = dom;
	}

	init() {
		const videoCards = Array.from(this.dom.querySelectorAll("[data-video]"));
		videoCards.forEach((card) => this._bindVideo(card));
		this._initScrollAnimation();
	}

	_initScrollAnimation() {
		const cards = Array.from(this.dom.querySelectorAll(".photo-collage__card"));

		const tl = gsap.timeline({ defaults: { ease: "power2.out", duration: 1 } });

		// Stagger order: card 3, 2, 4, 1, 5 (1-indexed → 0-indexed)
		const staggerOrder = [2, 1, 3, 0, 4];
		const staggerStep = 0.15;

		staggerOrder.forEach((cardIndex, staggerIndex) => {
			const card = cards[cardIndex];
			if (!card) return;
			tl.from(
				card,
				{
					y: randBetween(Y_MIN, Y_MAX),
					rotation: randBetween(ROT_MIN, ROT_MAX),
				},
				staggerIndex * staggerStep
			);
		});

		ScrollTrigger.create({
			trigger: this.dom,
			start: "top bottom",
			end: "center center",
			scrub: 1,
			animation: tl,
		});
	}

	_bindVideo(card) {
		const video = card.querySelector(".photo-collage__card-video");
		if (!video) return;

		card.addEventListener("mouseenter", () => {
			video.play();
			card.classList.add("is-playing");
		});

		card.addEventListener("mouseleave", () => {
			video.pause();
			video.currentTime = 0;
			card.classList.remove("is-playing");
		});
	}
}

Object.assign(PhotoCollage.prototype, event);
export default PhotoCollage;
